import React from 'react';
import { Entity } from '@backstage/catalog-model';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Card, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  card: {
    height: 420,
    minWidth: 300,
  },
  iframe: {
    padding: '20px',
    backgroundColor: '#ffffff',
  },
});

export const NewRelicContent = () => {
  const { entity } = useEntity();
  const classes = useStyles();

  const chartIds: string[] =
    entity.metadata.annotations?.['newrelic.com/chart-ids'].split(',') || [];

  const cardList = chartIds.map(el => (
    <Grid item xs={12} sm={12} md={12} lg={5} xl={4}>
      <Card className={classes.card} variant="outlined">
        <iframe
          className={`${classes.card} ${classes.iframe}`}
          title="1"
          width="inherit"
          frameBorder="0"
          scrolling="no"
          src={`https://chart-embed.service.newrelic.com/herald/${el}?height=400px&timepicker=false`}
        />
      </Card>
    </Grid>
  ));

  return (
    <>
      <Grid container justify="center" spacing={3}>
        {cardList}
      </Grid>
    </>
  );
};

export const isPluginApplicableToEntity = (entity: Entity) =>
  !!entity.metadata.annotations?.['newrelic.com/chart-ids'];
